export default __webpack_public_path__ + "static/media/Thumbup.c763fe1b.svg";